import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
//import S3 from 'aws-sdk/clients/s3';
import * as AWS from "aws-sdk";
import { environment } from '../../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class AwsS3BucketService {
  parentUrl: any;

  bucket = new AWS.S3({
    accessKeyId: environment.AWSS3BucketCredentials.accessKeyId,
    //accessKeyId: environment.AWSS3BucketCredentials.accessKeyId,
    secretAccessKey: environment.AWSS3BucketCredentials.secretToken,
    region: environment.AWSS3BucketCredentials.region,
    signatureVersion: 'v4',
  });

  /**
   * @param Observable<number>
   */
  private progress$: Observable<number>;

  /**
   * @type {number}
   */
  private progress: number = 0;

  private progressObserver: any;

  constructor(private httpReq: HttpClient) {
    this.progress$ = new Observable((observer) => {
      console.log(':::::::Constructor Observable');
      this.progressObserver = observer;
    });
   // this.parentUrl = environment.mySafeCabURL;
  }

  /**
   * Upload files through XMLHttpRequest
   *
   * @param url
   * @param files
   * @returns {Promise<T>}
   */
  public uploadFile(file: any, fileName: any): Promise<any> {
    var vm = this;
    const params: any = {
      Bucket: environment.AWSS3BucketCredentials.bucketName,
      Key: fileName,
      Body: file,
      ContentType: file.type,
      ACL: 'bucket-owner-full-control',

      // ContentType: 'MP4'
    };
    console.log('fileUpload_key', params);
    return new Promise((resolve, reject) => {
      console.log('awsupload', file, fileName);

      vm.bucket
        .upload(params, function (err: any, data: any) {
          if (err) {
            console.log('There was an error uploading your file: ', err);
            resolve(null);
          } else {
            console.log('Successfully uploaded file.', data);
            resolve(data);
          }
        })
        .on('httpUploadProgress', function (progress) {
          // event handling code
          console.log(
            'progress',
            Math.round((progress.loaded / progress.total) * 100)
          );

          AwsS3BucketService.setUploadUpdateInterval(500);
          vm.progressObserver.next(
            Math.round((progress.loaded / progress.total) * 100)
          );
        });
    }).catch((error) => {
      console.log('error', error);
    });
  }

  /**
   * Set interval for frequency with which Observable inside Promise will share data with subscribers.
   *
   * @param interval
   */
  private static setUploadUpdateInterval(interval: number): void {
    setInterval(() => {}, interval);
  }

  /**
   * @returns {Observable<number>}
   */
  public getObserver(): Observable<number> {
    console.log(':::::::RETURN GET OBSERVER');
    return this.progress$;
  }

  getPresignUrl(key: any) {
    //'https://preprod-sms.rntbciconnect.com' + '/presignedgeturl?key=' + key;
    const baseUrl ='https://rnconnect-ope.s3.ap-south-1.amazonaws.com/vdms/insurance/insurance_TN19AF9110_1716810244860.pdf'
    // this.parentUrl + 'presignedgeturl?key=' + key;
      
    return this.httpReq.get<any>(baseUrl);
  }
  // s3://rnconnect-ope/vdms/rcbook/rcbook_TN19AK9805_1716315988905.jpg
  // https://rnconnect-ope.s3.ap-south-1.amazonaws.com/vdms/rcbook/rcbook_TN19AK9805_1716315988905.jpg
  // generatePreSignedUrl(key: string): string {
  //   const params = {
  //     Bucket: environment.AWSS3BucketCredentials.bucketName,
  //     Key: key,
  //     Expires: 3600, // Set the expiration time in seconds (e.g., 1 hour)
  //   };

  //   return this.bucket.getSignedUrl('getObject', params);
  // }

  getPreSignedUrl(key: string): string {
    const params = {
      Bucket: environment.AWSS3BucketCredentials.bucketName,
      Key: key,
      Expires: 3600, // Set the expiration time in seconds (e.g., 1 hour)
    };

    return this.bucket.getSignedUrl('getObject', params);
  }

}
